import {
  Box,
  Card,
  CardActionArea,
  Divider,
  Stack,
  Typography
} from '@mui/material'
import { useGetPublicSubdomainQuery } from 'api/publicApi'
import { path, prop } from 'ramda'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import PollCard from 'pages/public/components/cards/PollCard'
import { StarBorder } from '@mui/icons-material'
import { sanitizeUrl } from 'utils/helpers'
import { Link } from 'react-router-dom'
import MiniSkillsCard from 'components/common/MiniSkillsCard'
import { useAnalytics, useCurrentAppType } from 'hooks'

const WelcomePollContentBlock = () => {
  const { cloudfront_domain } = useSelector(prop('school'))

  const { sendEvent } = useAnalytics()

  const { isVeteran } = useCurrentAppType()

  const staticData = {
    responder: [
      {
        pollQuestionId: 199,
        primaryCard: {
          id: 5874,
          image:
            'https://' +
            cloudfront_domain +
            '/uploads/DOHmlmZsrODMYDh6ArjlSNA48Ii0Woes2spgtUBW.jpeg',
          title: 'Listen, Learn…then Lead'
        },
        skillCards: [
          {
            id: 14371,
            image:
              'https://' +
              cloudfront_domain +
              '/uploads/Y9Ef7VDaZPGoOFDuGhHMfBrrkyPGmdi3AzOBU6N3.png',
            title: 'Get Mentally Fit for Duty'
          },
          {
            id: 14370,
            image:
              'https://' +
              cloudfront_domain +
              '/uploads/5M5M10tsI9ab878MA5jkN0HuGegx3fsOeEE4t9V4.png',
            title: 'Perform Under Pressure'
          }
        ],
        subdomainId: 91
      },
      {
        pollQuestionId: 202,
        primaryCard: {
          id: 13473,
          image:
            'https://' +
            cloudfront_domain +
            '/uploads/OW4GkVOdb0qTAXKsbtzKkFQTXvgj9seT8jHu1CV5.jpg',
          title: 'Not All Rest is Created Equal'
        },
        skillCards: [
          {
            id: 14377,
            image:
              'https://' +
              cloudfront_domain +
              '/uploads/Gv2siZkr8YM6y7cnA55sq5SeuWedYA2ro2CRvbr5.png',
            title: 'Calm Your Racing Mind'
          },
          {
            id: 14375,
            image:
              'https://' +
              cloudfront_domain +
              '/uploads/onaAdNuqrWmVDt3IBTlBjwUOAmzQMAAJYffHh2JE.png',
            title: 'Establish Sleep Hygiene'
          }
        ],
        subdomainId: 96
      },
      {
        pollQuestionId: 224,
        primaryCard: {
          id: 6088,
          image: 'https://img.youtube.com/vi/Ab7McWKrnbk/sddefault.jpg',
          title: 'Strength Through Community'
        },
        skillCards: [
          {
            id: 14405,
            image:
              'https://' +
              cloudfront_domain +
              '/uploads/Rbgc1zquAaAn1Y8v1os9qQA94V7kGtIaXn9KteT5.png',
            title: 'Get Involved'
          },
          {
            id: 14406,
            image:
              'https://' +
              cloudfront_domain +
              '/uploads/iBuy2L8Lfdz8ibPODaTOKnDcjenAPfxFkbumyoWx.png',
            title: 'Make Adult Friends'
          }
        ],
        subdomainId: 106
      }
    ],
    veteran: [
      {
        pollQuestionId: 123,
        primaryCard: {
          id: 2327,
          image:
            'https://' +
            cloudfront_domain +
            '/uploads/4IKUXPmRFZyeP0oDPjYPzPYBR6uPKe4uZnz7jQnW.jpeg',
          title: '3 Steps to Initial Success Following Discharge'
        },
        skillCards: [
          {
            id: 14171,
            image:
              'https://' +
              cloudfront_domain +
              '/uploads/7AWEq62RqJAlp7vERdKYXiXPHZukeNW3NWd9zwgy.png',
            title: 'Adapt to Civilian Culture'
          },
          {
            id: 14170,
            image:
              'https://' +
              cloudfront_domain +
              '/uploads/iJkuwwmD53SYMwm6Iq6OwedttXRqBbrCCu2nn7k6.png',
            title: 'Find Your Why'
          }
        ],
        subdomainId: 56
      },
      {
        pollQuestionId: 139,
        primaryCard: {
          id: 6167,
          image: 'https://img.youtube.com/vi/9TYXGuyxuwo/sddefault.jpg',
          title: 'Man Therapy: Feelings'
        },
        skillCards: [
          {
            id: 14149,
            image:
              'https://' +
              cloudfront_domain +
              '/uploads/8c9vzAFmFZXJGn1jv311BX7xzzeMoXWUrEr8Yhu1.png',
            title: 'Curb Anxiety & Stress'
          },
          {
            id: 14150,
            image:
              'https://' +
              cloudfront_domain +
              '/uploads/twED215gt5xTXSoAL6QLtzreb7L9W2ELBcN6i4Dm.png',
            title: 'Promote Peak Performance'
          }
        ],
        subdomainId: 64
      },
      {
        pollQuestionId: 111,
        primaryCard: {
          id: 13364,
          image:
            'https://' +
            cloudfront_domain +
            '/uploads/AFVaInL2fBPwmM4mQKgxH7fH2WRz29aC2i08gl6e.jpg',
          title: 'Community Veterans Support Group'
        },
        skillCards: [
          {
            id: 14199,
            image:
              'https://' +
              cloudfront_domain +
              '/uploads/nZo1NmQEcWjHgTNJeGUHLrFyYAvyMwTaVzxKIct1.png',
            title: 'Create a Veteran Community'
          },
          {
            id: 14202,
            image:
              'https://' +
              cloudfront_domain +
              '/uploads/h34bbLbpzOakowpMEycNo1kUIVQTsPDtw28VJzMv.png',
            title: 'Responder to a Veteran in Distress'
          }
        ],
        subdomainId: 50
      }
    ]
  }

  const content = isVeteran ? staticData.veteran : staticData.responder

  const [{ primaryCard, skillCards, subdomainId }] = useState(
    content[Math.floor(Math.random() * content.length)]
  )

  const school = useSelector(prop('school'))

  const org_domain = prop('domain', school)

  const { data = null } = useGetPublicSubdomainQuery({
    id: subdomainId,
    org: org_domain
  })

  const hasPoll = path(['poll_question', 'allow_as_poll_on_subdomain'], data)

  const handleFeaturedCardAnalytics = title => {
    sendEvent('block_interactions', {
      block_title: 'OFD Homepage Featured Card',
      element_title: title,
      path: '/'
    })
  }

  return (
    <>
      <Stack sx={{ width: 1 }}>
        <Box
          sx={{
            alignItems: 'center',
            alignSelf: 'flex-start',
            display: 'flex',
            px: 3
          }}
        >
          <StarBorder />
          <Typography ml="10px" variant="subtitle1">
            Featured
          </Typography>
        </Box>
        <Divider
          sx={{ mb: -3, ml: 'auto', mr: 'auto', width: { xs: 0.9, md: 1 } }}
          variant="middle"
        />
      </Stack>
      <Box
        sx={{
          display: 'grid',
          gridGap: { xs: 16, md: 32 },
          gridTemplateColumns: {
            xs: '1fr',
            md: '1fr 350px'
          },
          mb: { xs: 4, md: 0 },
          px: 3
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gridGap: 16
          }}
        >
          <Card
            sx={{
              borderRadius: 2,
              boxShadow: '0 2px 4px 0 rgba(79, 79, 79, 0.25)'
            }}
          >
            <CardActionArea
              component={Link}
              onClick={() => handleFeaturedCardAnalytics(primaryCard.title)}
              to={
                '/public/article/' +
                primaryCard.id +
                '/' +
                sanitizeUrl(primaryCard.title)
              }
            >
              <Box
                sx={{
                  backgroundImage: `url(${primaryCard.image})`,
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat',
                  backgroundSize: 'cover',
                  height: 350,
                  width: 1
                }}
              />
              <Typography sx={{ px: 3, py: 3 }} variant="h3">
                {primaryCard.title}
              </Typography>
            </CardActionArea>
          </Card>
          <Box
            sx={{
              display: 'grid',
              gridGap: 16,
              gridTemplateColumns: {
                xs: '1fr',
                lg: 'repeat(2, 1fr)',
                xl: 'repeat(2, 1fr)'
              },
              mx: 'auto',
              my: 3
            }}
          >
            {skillCards.map(card => (
              <MiniSkillsCard
                data-testid={card.id}
                handleAnalytics={() => handleFeaturedCardAnalytics(card.title)}
                headline={card.title}
                imageUrl={card.image}
                isWelcomePage={true}
                key={card.id}
                resourceUrl={`/public/article/${card.id}/${encodeURIComponent(
                  card.title
                )}`}
                subtitle="Learn How To..."
              />
            ))}
          </Box>
        </Box>
        {hasPoll && (
          <Box sx={{ pt: 0 }}>
            <PollCard
              content={prop('poll_question', data)}
              isWelcomePage={true}
            />
          </Box>
        )}
      </Box>
    </>
  )
}

export default WelcomePollContentBlock
